<main>
    <button on:click={updateCar}>Update Car</button>
    <div>{car_updated}</div>
</main>

<script>
    var car_updated = ''
    $: car_updated = car_updated

    function updateCar() {
        let key = '2'
        let car_record_update = {
                reg: 'AB123MNP',
                make: "Audi"
            }
        updateCarFromData(key, car_record_update)
    }

    async function updateCarFromData(key, car_data) {
        const url = "/.netlify/functions/database-access";
        const context = {
            access_type: 'update',
            record: car_data,
            key: key,
        }
        const event_pack = {
                body: JSON.stringify(context),
                method: "POST",
                "Content-Type": "application/json",
            }
        const update_record = await fetch(url, event_pack);
        const car = await update_record.json();

        if (car.message == 'instance already exists') {
            car_updated = `Record already exists: key=${key}`;
            return;
        }
        car_updated = `Car updated: ${car.reg}`;
    };
</script>